<template>
  <div class="d-flex flex-column">
  <div class="container-fluid">
      <h1 class="mr-3">Управление справочниками</h1>
  </div>
    <div class="d-flex flex-row flex-grow-0 justify-content-center mt-3">
    <div class="card">
      <h3 class="card-header"><span class="text-caps">Управление справочниками</span></h3>
      <div class="card-body">
        <div class="custom-file">
          <input type="file" @change="onFileChange" class="custom-file-input" lang="ru">
          <label class="custom-file-label">{{name}}</label>
        </div>
        <btn-action class="btn btn-primary my-2" :disabled="!catalog" @click="() => save()">Загрузить</btn-action>
        <div class="text-left">
          <a href="/api/admin/catalogs/download">Скачать актуальный файл конфигурации</a>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import api from '@/api'
  import BtnAction from '../../components/btn-action'
  export default {
    components: {BtnAction},
    data: () => ({
      catalog: null,
      name: 'Выберите файл...',
    }),
    methods: {
      onFileChange (e) {
        const files = e.target.files || e.dataTransfer.files
        if (!files.length) {
          return
        }
        this.name = files[0].name
        this.catalog = files[0]
      },
      save () {
        if (window.confirm('Загрузить выбранный справочник?')) {
          const data = new FormData()
          data.append('catalog', this.catalog)
          const headers = {'content-type': 'multipart/form-data'}
          return api.post('catalogs', data, {headers})
        }
      },
    },
  }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/catalogs.vue